/**
 * Weblink entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export const ContextItems = [{ value: 'cockpit_nav', text: 'CMS-Navigation' }];

export class Weblink extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            description: null,
            href: null,
            icon: null,
            context: null,
            roles: null,
            display_order: null,
            created: null,
            modified: null,
        };
    }

    mutations() {
        return {
            id: (id: number | string | null) => (Number(id) > 0 ? Number(id) : null),
            display_order: Number,
        };
    }

    entityName() {
        return 'Weblink';
    }
}

export class WeblinkCollection extends BaseCollection {
    options() {
        return {
            model: Weblink,
        };
    }

    entityName() {
        return 'Weblink';
    }
}
